import { render, staticRenderFns } from "./addTender.vue?vue&type=template&id=6c564780&scoped=true"
import script from "./addTender.vue?vue&type=script&lang=js"
export * from "./addTender.vue?vue&type=script&lang=js"
import style0 from "./addTender.vue?vue&type=style&index=0&id=6c564780&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c564780",
  null
  
)

export default component.exports